import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SuggestionDropdown from '../shared/SuggestionDropdown';
import { getIcon } from '../shared/FormatHelpers';
import { scrollToElement } from '../shared/EventHelpers';
import { ACTIVE, SELECT } from '../../../../../i18n/keyConstants';

const EditSelect = ({ iconName, value, setValue, options, onSave, isInvalid, isExl}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [activeIndex, setActiveIndex] = useState(-1);
    const ref = useRef();
    const icon = getIcon(iconName);
    const { t } = useTranslation('shared');
    useEffect(() => {
        const handleDocumentClick = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleDocumentClick);
        return () => {
            document.removeEventListener('mousedown', handleDocumentClick);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref]);

    const setSelectedItem = () => {
        if (activeIndex < 0 || activeIndex >= options.length) {
            return;
        }
        setValue(options[activeIndex]); // Options = array med alla userGroups
        setActiveIndex(-1);
        setIsOpen(false);
    };

    const scrollToIndex = (index) => {
        scrollToElement(`suggestion-${index}`);
    };

    const onKeyDown = (event) => {
        // Enter adds selected item
        if (event.keyCode === 13) {
            if (activeIndex >= 0 && isOpen) {
                setSelectedItem();
                event.preventDefault();
            } else if (isOpen) {
                setIsOpen(false);
            }else{
                setIsOpen(true);
            }
        }

        // Up-arrow moves up in list
        else if (event.keyCode === 38) {
            if (activeIndex > -1) {
                setActiveIndex(activeIndex - 1);
                scrollToIndex(activeIndex - 1);
            }
            event.preventDefault();
        }

        // Down-arrow moves down in list
        else if (event.keyCode === 40) {
            if (activeIndex < options.length - 1) {
                setActiveIndex(activeIndex + 1);
                scrollToIndex(activeIndex + 1);
            }
            event.preventDefault();
        }
    };

    const onMouseDown = (event) => {
        if (activeIndex >= 0) {
            setSelectedItem();
            event.preventDefault();
        }
    };

    return (
        <div className='crm-editable-field-wrapper' tabIndex={0} onKeyDown={onKeyDown}>
            <div ref={ref} className={`select-wrapper ${isOpen ? 'open' : 'closed'} ${isInvalid ? 'invalid' : ''} ${isExl ? 'isExl' : ''}`}>
                <div className='select' onClick={() => setIsOpen(!isOpen)}>
                    {icon}
                    {value?.name ?
                        <div className='select-text'>{`\u00A0${t(value?.name)}`}</div>
                        :
                        <div className='select-text select-text-placeholder'>{`\u00A0${t(SELECT)}`}</div>
                    }
                </div>
                <SuggestionDropdown
                    {...{
                        suggestions: options,
                        showSuggestions: isOpen,
                        activeIndex,
                        setActiveIndex,
                        onMouseDown,
                        disableScroll: options?.length && options.length < 10,
                    }}
                />
            </div>
        </div>
    );
};

export default EditSelect;
